export const GET_POPUP_PENDING = 'GET_POPUP_PENDING';
export const GET_POPUP_SUCCESS = 'GET_POPUP_SUCCESS';
export const GET_POPUP_FAIL = 'GET_POPUP_FAIL';

export const SAVE_SELECTION_PENDING = 'SAVE_SELECTION_PENDING';
export const SAVE_SELECTION_SUCCESS = 'SAVE_SELECTION_SUCCESS';
export const SAVE_SELECTION_FAIL = 'SAVE_SELECTION_FAIL';
